$(document).ready(function(){
      $('.my-slider').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        speed: 300,
        infinite: true,
        prevArrow:"<img class='prev_arow' alt='prev_arow' src='https://cdn.shopify.com/s/files/1/0513/0433/3506/files/Icon_Box_8.svg?v=1719317303'>",
        nextArrow:"<img  class='next_arow' alt='next_arow' src='https://cdn.shopify.com/s/files/1/0513/0433/3506/files/Icon_Box_7.svg?v=1719317303'>",
        autoplaySpeed: 5000,
        autoplay: true,
        responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 1,
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
        }
      }
    ]
      });
   $('.shop-all-slider').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        speed: 300,
        infinite: true,
        prevArrow:"<img class='prev_arow prev_arow_shop' alt='prev_arow' src='https://cdn.shopify.com/s/files/1/0513/0433/3506/files/Icon_Box_9.png?v=1719981761'>",
        nextArrow:"<img  class='next_arow next_arow_shop' alt='next_arow' src='https://cdn.shopify.com/s/files/1/0513/0433/3506/files/Icon_Box_10.png?v=1719981761'>",
        autoplaySpeed: 5000,
        autoplay: true,
        responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 4,
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
        }
      }
    ]
      });
    });

//review
 $('.custom_blocks_sec .flex_wrapper .outer_loop_new').slick({infinite: true,speed: 300,centerMode: true,  arrows:false, dots:true, centerPadding: '200px', slidesToShow: 2,slidesToScroll: 1, autoplay:true,
    responsive: [
      {
        breakpoint: 1380,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          centerMode: true,
          centerPadding: '200px',
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: true,
          centerPadding: '150px',
          infinite: true,
          dots: true
        }
      },
          {
        breakpoint: 750,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: true,
          centerPadding: '30px',
          infinite: true,
          dots: true
        }
      }

    ]
  });


//blog-banner
  $('.custom_blogs .flex_wrap .outer_loop_blog').slick({infinite: true,speed: 300, arrows:true, dots:false, slidesToShow: 1,slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1380,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true
        }
      },
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true
        }
      },
      {
        breakpoint: 750,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true
        }
      }
    ]
  });

//blog-filter-tag-slider
$('.blog_blocks_sec .flex_wrapper_blog .outer_loop_blog').slick({
    infinite: false,speed: 300,centerMode: true,  arrows:true, dots:true, slidesToShow: 9,slidesToScroll: 2,
    responsive: [
      {
        breakpoint: 1380,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1,
          centerMode: true,
          centerPadding: '200px',
          infinite: true
        }
      },
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          centerMode: true,
          centerPadding: '150px',
          infinite: true
        }
      },
      {
        breakpoint: 750,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          centerMode: true,
          centerPadding: '30px',
          infinite: true
        }
      }
    ]
  });

//Accordions

// class Accordion {
//   constructor(el) {
//     this.el = el;
//     this.summary = el.querySelector("summary");
//     this.content = el.querySelector(".accordion-content");
//     this.expandIcon = this.summary.querySelector(".accordion-icon");
//     this.animation = null;
//     this.isClosing = false;
//     this.isExpanding = false;
//     this.summary.addEventListener("click", (e) => this.onClick(e));
//   }
//   onClick(e) {
//     e.preventDefault();
//     this.el.style.overflow = "hidden";

//     if (this.isClosing || !this.el.open) {
//       this.open();
//     } else if (this.isExpanding || this.el.open) {
//       this.shrink();
//     }
//   }
//   shrink() {
//     this.isClosing = true;
//     const startHeight = `${this.el.offsetHeight}px`;
//     const endHeight = `${this.summary.offsetHeight}px`;
//     if (this.animation) {
//       this.animation.cancel();
//     }
//     this.animation = this.el.animate(
//       {
//         height: [startHeight, endHeight]
//       },
//       {
//         duration: 400,
//         easing: "ease-out"
//       }
//     );
//     this.animation.onfinish = () => {
//       this.expandIcon.setAttribute(
//         "src",
//         "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24'><path d='M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z'/></svg>"
//       );
//       return this.onAnimationFinish(false);
//     };
//     this.animation.oncancel = () => {
//       this.expandIcon.setAttribute(
//         "src",
//         "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24'><path d='M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z'/></svg>"
//       );
//       return (this.isClosing = false);
//     };
//   }
//   open() {
//     this.el.style.height = `${this.el.offsetHeight}px`;
//     this.el.open = true;
//     window.requestAnimationFrame(() => this.expand());
//   }
//   expand() {
//     this.isExpanding = true;

//     const startHeight = `${this.el.offsetHeight}px`;
//     const endHeight = `${
//       this.summary.offsetHeight + this.content.offsetHeight
//     }px`;
//     if (this.animation) {
//       this.animation.cancel();
//     }
//     this.animation = this.el.animate(
//       {
//         height: [startHeight, endHeight]
//       },
//       {
//         duration: 350,
//         easing: "ease-out"
//       }
//     );
//     this.animation.onfinish = () => {
//       this.expandIcon.setAttribute(
//         "src",
//         "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24'><path d='M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z'/></svg>"
//       );
//       return this.onAnimationFinish(true);
//     };
//     this.animation.oncancel = () => {
//       this.expandIcon.setAttribute(
//         "src",
//         "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24'><path d='M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z'/></svg>"
//       );
//       return (this.isExpanding = false);
//     };
//   }
//   onAnimationFinish(open) {
//     this.el.open = open;
//     this.animation = null;
//     this.isClosing = false;
//     this.isExpanding = false;
//     this.el.style.height = this.el.style.overflow = "";
//   }
// }
// document.querySelectorAll("details").forEach((el) => {
//   new Accordion(el);
// });